import React from 'react';

import {
  HeroContainer,
  HeroText,
  HeroImg,
  StyledHero,
  ScrollIndicator,
  Button,
} from './styles/Hero.styled';
import { HiCode } from 'react-icons/hi';
import { ReactComponent as HeroSVG } from '../assets/hero-img.svg';

const Hero = () => {
  return (
    <StyledHero id="home">
      <HeroContainer>
        <HeroText>
          <p className="greet">Hello 👋, I'm Lian Paul!</p>
          <h1>I build things </h1>
          <h2>for the web.</h2>
          <p className="desc">
            I'm a <span>Front-End Developer</span> who creates UX rich performant
            websites and web applications.
          </p>
          <Button
            to="projects"
            href="projects"
            smooth={true}
            duration={500}
            exact="true"
          >
            <HiCode />
            View Projects
          </Button>
          <ScrollIndicator />
        </HeroText>
        <HeroImg>
          <HeroSVG />
        </HeroImg>
      </HeroContainer>
    </StyledHero>
  );
};

export default Hero;
